import { render } from "./BankCardsDataTable.vue?vue&type=template&id=90f79528"
import script from "./BankCardsDataTable.vue?vue&type=script&lang=js"
export * from "./BankCardsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__